var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"page-empty",style:({paddingTop: _vm.paddingTop + 'px'})},[_c('img',{attrs:{"src":require(`@/assets/images/newUI/emptyData/${_vm.type}.png`)}}),_c('div',{staticClass:"empty-text"},[_vm._v(_vm._s(_vm.showText))])])
}
var staticRenderFns = []

export { render, staticRenderFns }